import Oidc from 'oidc-client'
import { deriveHttpsBaseURLFromLocation, getEnvUrlPathname } from '@/utils/runtimeBaseUrl'

/**
 * Derive OIDC server base from current hostname.
 * Examples:
 * - oaktest.gencagroup.com      -> https://gatetest.gencagroup.com/
 * - oaktest.shjinjia.com.cn     -> https://gatetest.shjinjia.com.cn/
 *
 * Falls back to process.env.BASE_OIDC_Server_URL when host is not oaktest.*
 */
export function getIdentityServerBase() {
  const derived = deriveHttpsBaseURLFromLocation({
    pathname: getEnvUrlPathname(process.env.BASE_OIDC_Server_URL, '/')
  })
  return derived || process.env.BASE_OIDC_Server_URL // 目标服务器登录地址
}

export const identityServerBase = getIdentityServerBase()
export const vueBase = process.env.BASE_OIDC_WEB_URL
export const ssoBase = process.env.BASE_OIDC_WEB_SSO_URL
export const client_secret = process.env.BASE_OIDC_WEB_CLIENT_SECRET || 'secret'
export const client_id = process.env.NODE_ENV === 'sit' ? 'js_oak_vue_uat' : 'js_oak_vue'

const config = {
  authority: `${identityServerBase}`, // OIDC/OAuth2 提供者的 URL
  client_id: client_id, // 客户端应用程序在 OIDC/OAuth2 提供程序中注册的标识符
  client_secret: client_secret,
  redirect_uri: `${vueBase}/callback.html`, // 客户端应用程序的重定向 URI，用于接收来自 OIDC/OAuth2 提供者的响应
  post_logout_redirect_uri: `${ssoBase}/logout`,
  scope: 'api openid profile offline_access',
  response_type: 'code',
  userStore: new Oidc.WebStorageStateStore({ store: window.localStorage })
}
export const mgr = new Oidc.UserManager(config)

